import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;  // Scroll main html
    document.body.scrollTop = 0;             // Scroll body
    window.scrollTo(0, 0);                   // Force window scroll
  }, [pathname]);

  return null;
}